import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    showSupportNotice: false,
    lng: 'en',
    lowerCaseLng: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    defaultNS: 'translation',
    backend: {
      loadPath: (lngs: string[], namespace: string[]) => {
        return `/locales/${lngs[0]}/${namespace[0]?.split(':').join('/')}.json`;
      },
    },
    returnEmptyString: false,
    parseMissingKeyHandler: key => {
      return import.meta.env.DEV ? `▓▒░ ${key} ░▒▓` : undefined;
    },
  });

export default i18n;
